import React from 'react';
import FeedCard from 'components/feed-card';
import { ItemDataType } from 'utils/types';
import { numberWithCommas } from 'utils/functions';

type Props = {
  item: ItemDataType;
};
const Item = ({ item }: Props) => {
  return (
    <div key={item.id}>
      <FeedCard className='w-full' image={item.images[0]}>
        <div className='flex justify-between items-center mt-2'>
          <div>
            <p className='text-sm'>{item?.name}</p>
            <p className='text-xs text-gray-5'>&#8358;{numberWithCommas(item.price)}</p>
          </div>
        </div>
      </FeedCard>
    </div>
  );
};

export default Item;
